"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var WirelessContents_1 = require("./WirelessContents");
exports.default = WirelessContents_1.default;
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@idse/cart-ui/components/CartLob/WirelessCart/WirelessContents/index.js
// module id = 780
// module chunks = 8